export default __webpack_public_path__ + "static/media/show-necklace-2.7ce03a3c.webp";